export const signTypedDataParams = async (
  // metamask provider type todo
  provider: any,
  address: string,
  msgParams: Record<string, any>
) => {
  return await provider.request({
    method: 'eth_signTypedData_v4',
    params: [address, JSON.stringify(msgParams)],
  });
};
